export default "__VITE_ASSET__df523884__"